<template>
  <div>
    <div class="card" :class="{ 'mix-red': data.statusTypeId === 14, 'red': data.statusTypeId === 12 }">
      <div class="card-body">
        <div class="card-title">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <status-label
                :type="data.statusTypeId === 5 ? 'orange' : '' || data.statusTypeId === 14 ? 'mixred' : '' || data.statusTypeId === 10 ? 'green' : '' || data.statusTypeId === 12 ? 'red' : ''" />
              <span class="status-text-card">{{ data.statusTypeName }}</span>
            </div>
            <div class="d-flex align-items-center">
              <el-button v-if="isAccidentOld" :title="$t('Gec_məlumat')"
                style="padding: 0 !important; margin-right: 5px; border: none !important; background: transparent !important"
                size="large">
                <div class="comm-icon" style="color: red;">
                  <i class="fa-solid fa-exclamation"></i>
                </div>
              </el-button>
            <span class="accident-icon" @dblclick="clickCard(data.id)">
  <router-link :to="`/accident/${data.id}`" style="font-size: var(--font-medium);">
    # {{ data.dispAccidentNumber }}
  </router-link>
</span>
            </div>
          </div>
        </div>

        <div class="card-text">
          <span class="info-text">
            <span class="info-label">{{$t('Sığorta_növü')}}:</span>
            {{ data.policyTypeName }}
          </span>
          <br />
          <span class="info-text">
            <span class="info-label">{{$t('Sığortalı')}}:</span>
            {{ data.insuredName }}
          </span>
          <br />
          <span class="info-text">
            <span class="info-label">{{$t('SŞ_nömrəsi')}}:</span>
            {{ data.policyNumber }}
          </span>
          <br />
          <span class="info-text small">
            <span class="info-label">{{$t('Hadisə_tarixi')}}:</span>
            {{ data.accidentDateStr }}
          </span>
          <br />
          <span class="info-text small">
            <span class="info-label">{{$t('Hadisə_yeri')}}:</span>
            {{ data.place }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { DateToString } from "../../services/helper";
  import StatusLabel from "../components/StatusLabel.vue";

  export default {
    components: { StatusLabel },
    props: {
      item: Object,
    },
    data() {
      return {
        data: this.item,
        statusCount: 0,
        showModal: false,
      };
    },

    computed: {
      isAccidentOld() {
        const twentyFourHours = 24 * 60 * 60 * 1000;
        const accidentDate = new Date(this.data.accidentDateStr.replace(/(\d{2})\.(\d{2})\.(\d{4})/, "$2/$1/$3"));
        const callDate = new Date(this.data.callDate.replace(/(\d{2})\.(\d{2})\.(\d{4})/, "$2/$1/$3"));
        const timeDifference = callDate.getTime() - accidentDate.getTime();
        return timeDifference >= twentyFourHours;
      }
    },

    methods: {
      handleCommand(command) {
        let id = command.id;
        if (command.action === "comm") this.handleComm(command.id);
      },
      handleComm(id) {
        this.checkStatusCount(id).then(() => {
          if (this.statusCount > 0) {
            this.$message({
              type: "warning",
              message: this.$t('Daha_öncə_Müştəri_xidmətinə_göndərilib'),
            });
          }
          else {
            this.$emit("send", id);
          }
        });
      },
      handleDelete(id) { },
      checkStatusCount(id) {
        this.statusCount = 0;
        return new Promise((resolve, reject) => {
          CheckStatusCount(id, 0, 30).then((response) => {
            if (response.data.data) {
              this.statusCount = response.data.data;
            }
            resolve(this.response);
          }, error => {
            reject(error);
          })
        })
      },
      clickCard(id) {
        // Handle double click event if needed
      }
    },
    watch: {
      item() {
        this.data = this.item;
      },
    },
    mounted() {
    },
  };
</script>

<style>
  /* Background colors */
  .progress {
    background-color: #fbfaf9;
  }

  .new {
    background-color: #ddf8f8;
  }

  .started {
    background-color: #a6f7cd;
  }

  .forward {
    background-color: #c1b7bc;
  }

  /* Border colors */
  .mix-red {
    border: 1px solid #B3005E;
  }

  .red {
    border: 1px solid red;
  }

  .status-text-card {
    margin-left: 8px;
    font-size: var(--font-medium);
    font-weight: bold;
    color: #3A3A3A;
  }

  .info-text {
    font-size: var(--font-medium);
    display: inline-block;
    margin-bottom: 2px;
  }

  .small {
   font-size: var(--font-primary);
  }

  .info-label {
    font-weight: bold;
    color: #3A3A3A;
  }

  .red-bold {
    color: red;
    font-weight: bold;
  }

  .comm-icon {
    color: red;
  }

  .card-text {
    line-height: 1.1;
  }
</style>